import { Link } from "react-router-dom";
import { Flame, ArrowLeft } from "lucide-react";

export default function Privacidade() {
  return (
    <div className="min-h-screen bg-[#090D16] text-slate-100 px-4 sm:px-6 py-12" data-testid="privacidade-page">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-emerald-400 hover:text-emerald-300 mb-8">
          <ArrowLeft className="w-4 h-4" /> Voltar para o início
        </Link>
        <div className="flex items-center gap-2.5 mb-6">
          <Flame className="w-6 h-6 text-emerald-400" />
          <span className="font-heading font-extrabold text-xl">MaturaMax</span>
        </div>
        <h1 className="font-heading text-3xl font-bold tracking-tight mb-6">Política de Privacidade</h1>
        <div className="space-y-4 text-sm text-slate-400 leading-relaxed">
          <p>Operamos sob uma infraestrutura de microsserviços isolados com criptografia de ponta a ponta (padrão AES-256) e tokens de sessão autenticados. Suas instâncias, históricos de conversas e dados privados rodam em um ambiente de nuvem proprietário e estritamente confidencial.</p>
          <p>Coletamos apenas o essencial para a operação: nome, e-mail, WhatsApp / telefone (utilizado para notificações operacionais da sua conta, avisos importantes e suporte direto da equipe) e dados de uso da plataforma. Pagamentos são processados integralmente pela InfinitePay — não armazenamos dados de cartão em nossos servidores.</p>
          <p>Não compartilhamos, vendemos ou rastreamos seus dados com terceiros. Você pode solicitar a exclusão da sua conta e dos seus dados a qualquer momento pelo e-mail suporte@maturamax.com.br.</p>
          <p>Esta política segue as diretrizes da Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018).</p>
        </div>
      </div>
    </div>
  );
}
